import { createSelector } from "reselect";
import { selectAuthSlice } from "../auth/selectors";

export const selectPreferencesSlice = state => state.preferences;

export const selectEvent = createSelector(
  selectPreferencesSlice,
  slice => slice.selectedEvent
);

// Mag weg
export const selectWeekend = createSelector(
  selectPreferencesSlice,
  slice => slice.weekend ?? 'wx'
);

// Company
export const selectCompany = createSelector(
  selectPreferencesSlice,
  selectAuthSlice,
  (preferences, auth) => {
    const companyId =
      typeof preferences.company === "object"
        ? preferences.company.id
        : preferences.company;

    const company = auth.user.companies.find(
      company => company.id === companyId
    );

    return company;
  }
);

// Registration selector
export const selectCompanyEvent = createSelector(
  selectPreferencesSlice,
  selectAuthSlice,
  (preferences, auth) => {
    const companyId =
      typeof preferences.company === "object"
        ? preferences.company.id
        : preferences.company;

    const company = auth.user.companies.find(
      company => company.id === companyId
    );

    if (!company) return undefined;

    const registration = company.registrations.find(
      reg => reg.id === preferences.companyRegistration
    );

    if (!registration) return undefined;

    return registration.event;
  }
);

// Company registration
export const selectCompanyRegistration = createSelector(
  selectPreferencesSlice,
  selectAuthSlice,
  (preferences, auth) => {
    const companyId =
      typeof preferences.company === "object"
        ? preferences.company.id
        : preferences.company;

    const company = auth.user.companies.find(
      company => company.id === companyId
    );

    if (!company) return undefined;

    const registration = company.registrations.find(
      reg => reg.id === preferences.companyRegistration
    );

    return registration;
  }
);

// Used for one feature
export const selectLastRentedMaterial = createSelector(
  selectPreferencesSlice,
  slice => slice.lastRentedMaterial
);
